export default "__VITE_ASSET__540b1f87__"